<div mat-dialog-title>
  <mat-icon>people</mat-icon>
  <h2>Change Reference Numbers</h2>
</div>
<div mat-dialog-content class="tc-deal-reference-numbers-content">
  <table class="tc-deal-reference-numbers-table">
    <thead>
      <tr>
        <th>Deal</th>
        <th>Supplier</th>
        <th>Supplier Ref #</th>
        <th>Buyer</th>
        <th>Buyer Ref #</th>
      </tr>
    </thead>
    <tbody>
      @for (row of deals; track row.dealId) {
        <tr>
          <td>{{ row.dealId }}</td>
          <td>{{ row.supplier }}</td>
          <td>
            <mat-form-field subscriptSizing="dynamic" class="tc-ref-input">
              <mat-label>Supplier ref. number</mat-label>
              <input matInput type="text" [(ngModel)]="row.supplierRefNumber" placeholder="Supplier ref. num..." />
            </mat-form-field>
          </td>
          <td>{{ row.buyer }}</td>
          <td>
            <mat-form-field subscriptSizing="dynamic" class="tc-ref-input">
              <mat-label>Buyer ref. number</mat-label>
              <input matInput type="text" [(ngModel)]="row.buyerRefNumber" placeholder="Buyer ref. number" />
            </mat-form-field>
          </td>
        </tr>
      }
    </tbody>
  </table>
</div>
<div mat-dialog-actions align="end">
  <button mat-button type="button" (click)="cancel()">CANCEL</button>
  <button mat-raised-button color="primary" type="button" (click)="update()" [disabled]="(!hasChanges || loading)" [class.tc-update-loading]="loading">
    @if (loading) {
      <mat-spinner diameter="20"></mat-spinner>
    }
    @if (!loading) {
      <mat-icon>check</mat-icon>
    }
    @if (!loading) {
      <span>UPDATE</span>
    }
  </button>
</div>
